import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

// ── Zones ────────────────────────────────────────────────────────────────────

export const fetchZones = async (): Promise<any[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/zones`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta zoner'); }
};

export const createZone = async (zone: any): Promise<any> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/zones`, zone);
        return res.data;
    } catch (error) { return handleApiError(error, 'Skapa zon'); }
};

export const updateZone = async (id: number, zone: any): Promise<any> => {
    try {
        const res = await axios.put(`${API_BASE_URL}/zones/${id}`, zone);
        return res.data;
    } catch (error) { return handleApiError(error, 'Spara zon'); }
};

export const deleteZone = async (id: number): Promise<any> => {
    try {
        const res = await axios.delete(`${API_BASE_URL}/zones/${id}`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Ta bort zon'); }
};
